import { render, staticRenderFns } from "./confirmOrder.vue?vue&type=template&id=cd2b0e2e&scoped=true&"
import script from "./confirmOrder.vue?vue&type=script&lang=js&"
export * from "./confirmOrder.vue?vue&type=script&lang=js&"
import style0 from "./confirmOrder.vue?vue&type=style&index=0&id=cd2b0e2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2b0e2e",
  null
  
)

export default component.exports